@if (booting()) {
  <div class="fixed inset-0 z-[10000] flex items-center justify-center bg-background">
    <div class="flex items-center gap-1.5">
      <span class="size-2.5 rounded-full bg-text-secondary/60 animate-bounce [animation-delay:-0.3s]"></span>
      <span class="size-2.5 rounded-full bg-text-secondary/60 animate-bounce [animation-delay:-0.15s]"></span>
      <span class="size-2.5 rounded-full bg-text-secondary/60 animate-bounce"></span>
    </div>
  </div>
} @else {
  <router-outlet />
}
